import moment from "moment";
import { LAST_30_DAYS, LAST_12_MONTH, CURRENT_QUARTER, YEAR_TO_DATE } from "../constant/filters";
import { DATE_FORMAT } from "./date";

const parseFilterValues = (filters) => {
  const format = (m) => m.format("YYYY-MM-DD HH:mm");
  let fromDate;
  let toDate;
  if (filters.value) {
    switch (filters.value) {
      case LAST_12_MONTH:
        fromDate = format(moment().subtract(12, "months").startOf("day"));
        toDate = format(moment().endOf("day"));
        break;
      case LAST_30_DAYS:
        fromDate = format(moment().subtract(30, "days").startOf("day"));
        toDate = format(moment().endOf("day"));
        break;
      case CURRENT_QUARTER:
        fromDate = format(moment().startOf("quarter").startOf("day"));
        toDate = format(moment().endOf("quarter").endOf("day"));
        break;
      case YEAR_TO_DATE:
        fromDate = format(moment().startOf("Y").startOf("day"));
        toDate = format(moment().endOf("day"));
        break;
    }
  }
  if (filters.fromDate) {
    fromDate = moment(filters.fromDate, DATE_FORMAT).startOf("d");
  }
  if (filters.toDate) {
    toDate = moment(filters.toDate, DATE_FORMAT).endOf("d");
  }

  return { fromDate, toDate };
};

export { parseFilterValues };
